import { Fragment } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useNavigazione } from "../context/navigazione";
import Footer from "../components/footer";
import PrivateRoute from "../components/private-route";
import GenericPage from "./generic-page";
import Articolo from "./article";
import EdizioniPrecedenti from "./edizioni-precedenti";
import Home from "./home";
import Programma from "./programma";
import Protagonisti from "./protagonisti";
import ProgrammaScuole from "./programma-scuole";
import AreaClienti from "./area-clienti";
import Registrazione from "./registrazione";
import Profilo from "./profilo";
import ConfermaRegistrazione from "./conferma-registrazione";
import PasswordDimenticata from "./password-dimenticata";
import InserisciUtente from "./inserisci-utente";
import NotFound from "./not-found";
import Newsletter from "./newsletter";
import Sponsor from "./sponsor";
import BannerSponsor from "../components/banner-sponsor";
import ScriviAlFestival from "./scrivi-al-festival";

const PageTemplate = ({ page }) => {
  const breadcrumb = [
    {
      label: "Home",
      link: "/",
    },
  ]
    .concat(
      page.parent
        ? {
            label: page.parent.name,
            link: page.parent.link,
          }
        : [],
    )
    .concat([
      {
        label: page.name,
      },
    ]);
  return (
    {
      generic: (
        <GenericPage page={page} breadcrumbs={breadcrumb} key={page.link} />
      ),
      archivio: (
        <EdizioniPrecedenti
          page={page}
          breadcrumbs={breadcrumb}
          key={page.link}
        />
      ),
      home: <Home page={page} key={page.link} />,
      programma: (
        <Programma page={page} breadcrumbs={breadcrumb} key={page.link} />
      ),
      protagonisti: (
        <Protagonisti page={page} breadcrumbs={breadcrumb} key={page.link} />
      ),
      programmaScuole: (
        <ProgrammaScuole page={page} breadcrumbs={breadcrumb} key={page.link} />
      ),
      areaClienti: (
        <AreaClienti page={page} breadcrumbs={breadcrumb} key={page.link} />
      ),

      newsletter: (
        <Newsletter page={page} breadcrumbs={breadcrumb} key={page.link} />
      ),
      sponsor: <Sponsor page={page} breadcrumbs={breadcrumb} key={page.link} />,
      scriviFestival: (
        <ScriviAlFestival
          page={page}
          breadcrumbs={breadcrumb}
          key={page.link}
        />
      ),
    }[page.template] || null // <Error msg={`Missing template ${page.pageTemplate}`} key={page.link} />
  );
};

const AppRoutes = () => {
  const {
    pages,
    sponsor: showSponsor,
    footer,
    isLoading,
    getPageByTemplate,
  } = useNavigazione();
  const programmaPage = getPageByTemplate("programma");

  return !isLoading ? (
    <>
      <Routes>
        {pages.map((item) => (
          <Fragment key={item.link}>
            {item.template && (
              <Route path={item.link} element={<PageTemplate page={item} />} />
            )}
            {item?.pages
              ?.filter((i) => i.template && i.link !== item.link)
              .map((sitem) => (
                <Route
                  path={sitem.link}
                  element={<PageTemplate page={sitem} />}
                  key={sitem.link}
                />
              ))}
          </Fragment>
        ))}

        <Route
          path="/profilo"
          element={<PrivateRoute component={<Profilo />} />}
        />

        <Route
          path="/inserisci-utente"
          element={<PrivateRoute component={<InserisciUtente />} />}
        />
        <Route path="/registrazione" element={<Registrazione />} />
        <Route
          path="/conferma-registrazione"
          element={<ConfermaRegistrazione />}
        />
        <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
        <Route path={`/news/:slug`} element={<Articolo />} />
        <Route path="/site/*" element={<Navigate to="/" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer data={footer} />
      {showSponsor && <BannerSponsor />}
    </>
  ) : (
    <div></div>
  );
};

export default AppRoutes;
